import { TAppDispatch, TGetState } from 'store/types'
import { userThunks } from 'store/features/user/thunks'
import { userSelectors } from 'store/features/user/selectors'

interface IStorageCheckResult {
  canUpload: boolean
  freeStorage: number | null
}

export const checkStorageBeforeUpload = async (
  filesSize: number,
  dispatch: TAppDispatch,
  getState: TGetState
): Promise<IStorageCheckResult> => {
  //fetch latest user stats before checking storage
  await dispatch(userThunks.getUserStats())

  const state = getState()
  const isStorageFull = userSelectors.isStorageFull(state)
  const freeStorage = userSelectors.freeStorageSize(state)

  //check if storage is full or file size exceeds available storage
  if (isStorageFull || (freeStorage !== null && filesSize > freeStorage)) {
    return { canUpload: false, freeStorage }
  }

  return { canUpload: true, freeStorage }
}
